import axios from 'axios'
// import qs from 'qs'
import { getToken, removeToken } from './auth.js'
import store from '@/store'
import { MessageBox, Message } from 'element-ui'
import { CODE_OK } from '@/utils/config'
import { isInjectToGeoTab } from '@/utils'

const noAccessCodes = ['10131004', '10131006', '10131007', '10131009', '10131011', '10100']
const reloadCodes = ['242001', '10131019']

let notAlertErrorMessage = false

// return headers
const returnHeaders = ['x-pagination-current-page', 'x-pagination-limit', 'x-pagination-total-count', 'x-pagination-total-pages'];
function getHeaders(headers) {
    const newHeaders = {}
    returnHeaders.forEach(header => {
        if(headers[header] !== undefined) {
            newHeaders[header] = headers[header];
        }
    })
    return newHeaders
}

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API + '/api', // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000 // request timeout
})


// request interceptor
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers['Authorization'] = getToken()
        }

        // keyword trim()
        if(config.params && config.params.q && config.params.q.keyword !== undefined) {
            config.params.q.keyword = (config.params.q.keyword + '').trim()
        }

        notAlertErrorMessage = config.notAlert

        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        if(response.status == 204) {
            return Promise.resolve({http_code: 204, code: CODE_OK, message: 'OK'})
        }else {
            const headers = getHeaders(response.headers)
            // console.log('response headers', response.headers)
            return Promise.resolve(Object.assign({http_code: response.status, headers}, response.data));
        }
    },
    error => {
        // console.log('err', error, error.response) // for debug
        if(error.response) {
            const { status, data } = error.response;
            const message = data.message;
            if(status === 401 || noAccessCodes.indexOf(data.code) > -1) {
                removeToken()
                localStorage.clear()

                const isInjectGeoTab = isInjectToGeoTab()
                if (isInjectGeoTab) {
                    window.parent.postMessage({ cmd: 'Expired' }, '*')
                } else {
                    MessageBox.alert(message, 'Tips', {
                        type: 'error',
                        callback: () => {
                            if(location.pathname !== '/login'){
                                if(location.pathname && location.pathname !== '/force_reset_password') {
                                    location.href = '/login?redirect=' + window.location.pathname;
                                }else {
                                    location.href = '/login'
                                }
                            }
                        }
                    });
                }
            }else if(!notAlertErrorMessage) {
                if (reloadCodes.indexOf(data.code) > -1){
                    MessageBox.alert(message, 'Tips', {
                        type: 'error',
                        callback: (action) => {
                            if (action === 'confirm') {
                                window.location.reload()
                            }
                        }
                    });
                }else if (status === 403){
                    MessageBox.alert(message, 'Tips', {
                        type: 'error'
                    });
                }else {
                    MessageBox.alert(message || status, 'Tips', {
                        type: 'error',
                    });
                }
            }
            return Promise.reject(Object.assign({http_code: status}, data)) 
        }else {
            const message = 'Sorry, maybe the network issue occurs, please try again.';
            // MessageBox.alert(message, 'Tips', {
            //     type: 'error'
            // });
            Message.error(message)
            return Promise.reject({http_code: 0, code: -999, message}) 
        }
        
    }
)

export default service
